import React from 'react';
import { observer } from 'mobx-react-lite';
import { userInfoStore, useTranslation, gameConfigStore } from '@pascal/pascal-core';
import { translationKeys } from '../../enums/translations';
import { touchMeGameId } from '../../enums/gameConstant';

const multiplierOdds = [2, 3, 5];
const MultiplierNotePopup = observer(({ handleIsShowChange }) => {
  const { MULTIPLIER_POP_UP_TITLE, MULTIPLIER_POP_UP_DESC, CashOut } = translationKeys;
  const { limits, gameId } = gameConfigStore;
  const { currencySymbolOrCode } = userInfoStore;
  const t = useTranslation();

  return touchMeGameId === +gameId ? (
    <div className='tutorial-modal-wrapper'>
      <div className='tutorial-modal'>
        <div className='tutorial-modal-header'>
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <button
            type='button'
            className='tutorial-modal-close icon-close'
            onClick={() => handleIsShowChange(true)}
          />
        </div>
        <div className='tutorial-modal-body'>
          <div className='tutorial-illustration'>
            <p className='illustration-label'>
              {limits?.maxWin} {currencySymbolOrCode}
              <span>{t(CashOut)}</span>
            </p>
            <p className='illustration-odd'>x1000</p>
          </div>
          <div className='tutorial-content'>
            <h5 className='tutorial-content-title'>
              {t(MULTIPLIER_POP_UP_TITLE)}
              <span>
                {multiplierOdds.map(
                  (item, index) => ` x${item}${index !== multiplierOdds.length - 1 ? ',' : ''}`
                )}
              </span>
            </h5>
            <p className='tutorial-content-paragraph'>{t(MULTIPLIER_POP_UP_DESC)}</p>
          </div>
          {/* <div className='tutorial-content-navigation'> */}
          {/*  <div className='tutorial-content-nav-dots'> */}
          {/*    /!* eslint-disable-next-line jsx-a11y/control-has-associated-label *!/ */}
          {/*    <button type='button' className='tutorial-content-nav-dot active' /> */}
          {/*    /!* eslint-disable-next-line jsx-a11y/control-has-associated-label *!/ */}
          {/*    <button type='button' className='tutorial-content-nav-dot' /> */}
          {/*  </div> */}
          {/*  <div className='tutorial-content-arrows'> */}
          {/*    /!* eslint-disable-next-line jsx-a11y/control-has-associated-label *!/ */}
          {/*    <button type='button' className='tutorial-content-arrow icon-arrow-left' /> */}
          {/*    /!* eslint-disable-next-line jsx-a11y/control-has-associated-label *!/ */}
          {/*    <button */}
          {/*      type='button' */}
          {/*      className='tutorial-content-arrow icon-arrow-right active' */}
          {/*    /> */}
          {/*  </div> */}
          {/* </div> */}
        </div>
        {/* <div className='tutorial-modal-footer'> */}
        {/*  <label className='tutorial-show-again'> */}
        {/*    <input */}
        {/*      type='checkbox' */}
        {/*      onChange={(e) => { */}
        {/*        setIsDontShowAgainChecked(e.target.checked); */}
        {/*      }} */}
        {/*    /> */}
        {/*    <span className='tutorial-show-checkbox' /> */}
        {/*    <span className='tutorial-show-label'>Please, don't show it again</span> */}
        {/*  </label> */}
        {/* </div> */}
      </div>
    </div>
  ) : (
    <></>
  );
});

export default MultiplierNotePopup;
